import { useCallback } from "react";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import layout from "../../constants/layout";
import useDisclosure from "./useDisclosure";

export default function useDrawer() {
  const disc = useDisclosure();

  const DrawerComplete = useCallback(
    ({ children, ...props }) => {
      return (
        <Drawer {...disc.getDisclosureProps()} {...props}>
          <Box
            sx={{
              ...(props.sx || {}),
              paddingTop: `${layout.navBarHeight + 1}rem`,
            }}
          >
            {children}
          </Box>
        </Drawer>
      );
    },
    [disc]
  );

  return {
    disclosure: disc,
    open: disc.isOpen,
    setOpen: (open) => (open ? disc.onOpen() : disc.onClose()),
    Drawer: DrawerComplete,
  };
}
